import(/* webpackMode: "eager" */ "/vercel/path0/apps/client-website/src/app/global-error.tsx");
